var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("UploadDocument", {
    attrs: {
      currentUserId: _vm.currentUserId,
      currentUser: _vm.currentUser,
      preventAutoUploading: "",
    },
    on: { fileUpdated: _vm.attachNewFile },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ addFile, removeFile, uploadFile }) {
          return [
            _c("ModalFullScreen", {
              attrs: { size: "lg", title: _vm.applicationTitle },
              on: {
                close: function ($event) {
                  return _vm.$emit("close")
                },
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "form",
                    fn: function () {
                      return [
                        _c("div", { staticClass: "flex" }, [
                          _c(
                            "div",
                            { staticClass: "w-7/12" },
                            [
                              _c("CardBodyItem", {
                                attrs: {
                                  label: "Company",
                                  content: _vm.companyName,
                                  labelClass: "w-28",
                                },
                              }),
                              _c("CardBodyItem", {
                                attrs: {
                                  label: "Location",
                                  content: _vm.location,
                                  labelClass: "w-28",
                                },
                              }),
                              _c("CardBodyItem", {
                                attrs: {
                                  label: "Employment type",
                                  content: _vm.employmentType,
                                  labelClass: "w-28",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _vm.postingDuration
                                ? _c("CardBodyItem", {
                                    attrs: {
                                      label: "Duration",
                                      content: _vm.postingDuration,
                                      wide: "",
                                    },
                                  })
                                : _vm._e(),
                              _c("CardBodyItem", {
                                attrs: {
                                  label: "Posted date",
                                  content: _vm.postedDate,
                                  wide: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c(
                          "CardBodyItem",
                          { attrs: { label: "Skills", labelClass: "w-28" } },
                          [
                            _c("ItemChipsWithMore", {
                              attrs: { items: _vm.skills, limit: 30 },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "CardBodyItem",
                          {
                            attrs: { label: "Industries", labelClass: "w-28" },
                          },
                          [
                            _c("ItemChipsWithMore", {
                              attrs: { items: _vm.industries, limit: 10 },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "CardBodyItem",
                          {
                            class: _vm.descriptionClasses,
                            attrs: { label: "Description", labelClass: "w-28" },
                          },
                          [
                            _c("CollapsibleDescription", {
                              attrs: { description: _vm.description },
                            }),
                          ],
                          1
                        ),
                        _vm._t("default"),
                        _c("div", { staticClass: "mb-5" }, [
                          !_vm.newFile
                            ? _c(
                                "div",
                                { staticClass: "text-label" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex items-baseline mb-1" },
                                    [
                                      _c("UiButton", {
                                        staticClass: "mr-1",
                                        attrs: {
                                          buttonText: "Attach new document",
                                          variant: "linkButton",
                                          size: "no",
                                        },
                                        on: { click: addFile },
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "text-gray-600" },
                                        [
                                          _vm._v(
                                            " or select document from the list: "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("DocumentMultiselect", {
                                    attrs: {
                                      conditions:
                                        _vm.documentMultiselectConditions,
                                    },
                                    on: {
                                      selectedRemoved:
                                        _vm.clearDocumentMultiselect,
                                    },
                                    model: {
                                      value: _vm.attachedDocumentIds,
                                      callback: function ($$v) {
                                        _vm.attachedDocumentIds = $$v
                                      },
                                      expression: "attachedDocumentIds",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                [
                                  _c(
                                    "CardBodyItem",
                                    {
                                      attrs: {
                                        label: "Attached document",
                                        labelClass: "w-auto mr-2",
                                      },
                                    },
                                    [
                                      _c("AttachedDocument", {
                                        attrs: { name: _vm.newFile.name },
                                        on: { remove: removeFile },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "actions",
                    fn: function () {
                      return [
                        _c("ModalSectionsDivider"),
                        _c(
                          "div",
                          { staticClass: "flex pt-5" },
                          [
                            _c("UiButton", {
                              staticClass: "mr-4",
                              attrs: {
                                buttonText: "Cancel",
                                variant: "outline",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("close")
                                },
                              },
                            }),
                            _c("UiButton", {
                              attrs: {
                                buttonText: _vm.actionButtonText,
                                disabled: false,
                                processing: _vm.processing,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.update(uploadFile)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                true
              ),
            }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }